var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Nav from "react-bootstrap/Nav";
import { styleBlock } from "../styleBlock";
const TabsNav = (_a) => {
    var { activeId, tabs, className } = _a, props = __rest(_a, ["activeId", "tabs", "className"]);
    const classNames = styleBlock("tabsnav");
    const cn = classNames({}).mix([className]);
    return (React.createElement("div", { className: cn.toString() },
        React.createElement(Nav, { variant: "tabs" }, tabs &&
            tabs.map((tab, index) => {
                return (React.createElement(Nav.Item, { key: "tablink-" + index },
                    React.createElement(Nav.Link, { href: tab.href, active: tab.id === activeId, onClick: tab.onClick }, tab.title)));
            }))));
};
export default TabsNav;
//# sourceMappingURL=index.js.map